import { Injectable } from '@angular/core';

import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class EdiExportProcService {
    constructor(private dataTask: DataTaskService) {}

    /**
     * @datatask 991
     * @datataskName sp_ws_p2_edi_exportproc_table_name_ext_list
     * @param params Table name list parameters.
     * @returns Promise containing the available table names.
     */
    public getTableNamesList(params: EdiExportProcTableNameListParams): Promise<EdiExportProcTableNameItem[]> {
        return this.dataTask.Post(991, params);
    }
}

export interface EdiExportProcTableNameListParams {}

export interface EdiExportProcTableNameItem {
    table_name: string;
    table_name_translated: string;
}
